export default __webpack_public_path__ + "assets/images/73fab3aca191b0d326f2ee94b53a7b34.svg";